import React, { useState, useEffect, useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiCall } from '../utils/api';
import './PartnerRegistration.css';

const INDIA_STATES_CITIES = {
  'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Kadapa', 'Tirupati', 'Rajahmundry', 'Kakinada', 'Eluru'],
  'Arunachal Pradesh': ['Itanagar', 'Naharlagun', 'Pasighat', 'Tezpur'],
  'Assam': ['Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia', 'Tezpur'],
  'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Darbhanga', 'Purnia', 'Arrah', 'Begusarai'],
  'Chhattisgarh': ['Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg', 'Rajnandgaon'],
  'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda'],
  'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Gandhinagar', 'Anand', 'Junagadh'],
  'Haryana': ['Faridabad', 'Gurgaon', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar', 'Karnal', 'Sonipat'],
  'Himachal Pradesh': ['Shimla', 'Dharamshala', 'Solan', 'Mandi', 'Kullu', 'Manali', 'Kangra'],
  'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Deoghar', 'Hazaribagh'],
  'Karnataka': ['Bengaluru', 'Mysuru', 'Mangaluru', 'Hubballi', 'Belagavi', 'Davanagere', 'Ballari', 'Tumkur', 'Udupi'],
  'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Kollam', 'Thrissur', 'Palakkad', 'Alappuzha', 'Kottayam'],
  'Madhya Pradesh': ['Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Rewa', 'Satna', 'Dewas'],
  'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Thane', 'Aurangabad', 'Solapur', 'Amravati', 'Kolhapur', 'Navi Mumbai'],
  'Manipur': ['Imphal', 'Thoubal', 'Bishnupur'],
  'Meghalaya': ['Shillong', 'Tura', 'Nongstoin'],
  'Mizoram': ['Aizawl', 'Lunglei', 'Saiha'],
  'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung'],
  'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur', 'Puri', 'Balasore'],
  'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali', 'Firozpur', 'Pathankot'],
  'Rajasthan': ['Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar', 'Bharatpur', 'Sikar'],
  'Sikkim': ['Gangtok', 'Namchi', 'Gyalshing'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Vellore', 'Erode', 'Tiruppur'],
  'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam', 'Ramagundam', 'Mahbubnagar'],
  'Tripura': ['Agartala', 'Dharmanagar', 'Udaipur'],
  'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Meerut', 'Allahabad', 'Ghaziabad', 'Noida', 'Bareilly', 'Aligarh', 'Moradabad', 'Saharanpur', 'Mathura', 'Vrindavan', 'Ayodhya'],
  'Uttarakhand': ['Dehradun', 'Haridwar', 'Rishikesh', 'Nainital', 'Roorkee', 'Haldwani', 'Mussoorie', 'Rudrapur'],
  'West Bengal': ['Kolkata', 'Asansol', 'Siliguri', 'Durgapur', 'Bardhaman', 'Malda', 'Baharampur', 'Howrah'],
  'Delhi': ['New Delhi', 'Dwarka', 'Rohini', 'Janakpuri', 'Lajpat Nagar', 'Connaught Place', 'Saket', 'Karol Bagh', 'Pitampura'],
  'Chandigarh': ['Chandigarh'],
  'Puducherry': ['Puducherry', 'Karaikal', 'Yanam'],
  'Jammu & Kashmir': ['Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore'],
  'Ladakh': ['Leh', 'Kargil'],
};

const SearchableSelect = ({ label, value, onChange, options, placeholder, required, error }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  const filtered = options.filter(o => o.toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="form-group" ref={ref} style={{ position: 'relative', zIndex: open ? 9999 : 1 }}>
      <label>{label}{required && <span className="required-asterisk"> *</span>}</label>
      <div
        className="form-control"
        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', userSelect: 'none' }}
        onClick={() => setOpen(o => !o)}
      >
        <span style={{ color: value ? '#333' : '#aaa' }}>{value || placeholder}</span>
        <span style={{ fontSize: '11px', color: '#888' }}>{open ? '▲' : '▼'}</span>
      </div>
      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #d0d0d0',
          borderRadius: '6px',
          zIndex: 99999,
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
          maxHeight: '260px',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '2px',
          overflow: 'hidden'
        }}>
          <input
            autoFocus
            type="text"
            placeholder="Search..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            onClick={e => e.stopPropagation()}
            style={{ padding: '9px 12px', border: 'none', borderBottom: '1px solid #eee', outline: 'none', fontSize: '14px', flexShrink: 0 }}
          />
          <div style={{ overflowY: 'auto', maxHeight: '210px' }}>
            <div
              style={{ padding: '8px 12px', cursor: 'pointer', color: '#aaa', fontSize: '13px' }}
              onClick={() => { onChange(''); setOpen(false); setSearch(''); }}
            >
              — None —
            </div>
            {filtered.map(opt => (
              <div
                key={opt}
                style={{ padding: '9px 14px', cursor: 'pointer', background: opt === value ? '#eef6ff' : 'transparent', fontWeight: opt === value ? '600' : '400', fontSize: '14px', borderLeft: opt === value ? '3px solid #4f7ef5' : '3px solid transparent' }}
                onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
                onMouseEnter={e => { if (opt !== value) e.currentTarget.style.background = '#f5f5f5'; }}
                onMouseLeave={e => { e.currentTarget.style.background = opt === value ? '#eef6ff' : 'transparent'; }}
              >
                {opt}
              </div>
            ))}
            {filtered.length === 0 && <div style={{ padding: '10px 14px', color: '#aaa', fontStyle: 'italic' }}>No results found</div>}
          </div>
        </div>
      )}
      {error && <span className="form-error-msg">{error}</span>}
    </div>
  );
};

const PartnerRegistration = () => {
  const location = useLocation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [formData, setFormData] = useState({
    fullName: '', gender: '', dob: '', mobile: '', email: '', city: '', state: '', pinCode: '',
    registrationType: '', 
    yearsOfExperience: '', yogaSpecializations: [], customSpecialization: '', isCertified: '', certificationDetails: '', typesOfClasses: [], languagesSpoken: '',
    studioName: '', ownerName: '', studioAddress: '', numberOfTrainers: '', typesOfYogaOffered: '', batchCapacity: '', workingDaysTimings: '', amenities: [],
    feeType: '', feeAmount: '', freeTrial: '', specialPrograms: [], customSpecialProgram: '',
    websiteLink: '', instagramProfile: '', youtubeChannel: '', googleMapsLocation: '',
    acceptingNewClients: '', interestedIn: [], preferredServiceAreas: '',
    whyJoinYogaKarega: '', additionalInfo: '', confirmInformation: false, agreeToBeListed: false,
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    if (type === 'trainer' || type === 'studio') {
      setFormData(prev => ({ ...prev, registrationType: type }));
    }
  }, [location.search]);

  const yogaSpecializationsList = ['Hatha Yoga', 'Vinyasa Yoga', 'Ashtanga Yoga', 'Power Yoga', 'Meditation', 'Pranayama', 'Therapeutic Yoga'];
  const specialProgramsList = ['Weight Loss', 'Medical / Therapy Yoga', 'Meditation Programs', 'Corporate Yoga', 'Kids Yoga', 'Prenatal Yoga'];
  const collaborationList = ['Collaboration with Yoga Karega India', 'Corporate Yoga Events', 'Online Programs'];
  const amenitiesList = ['AC', 'Parking', 'Mats Provided', 'Changing Rooms', 'Showers'];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name === 'confirmInformation' || name === 'agreeToBeListed') {
        setFormData(prev => ({ ...prev, [name]: checked }));
      } else {
        setFormData(prev => {
          const arr = prev[name] || [];
          if (checked) return { ...prev, [name]: [...arr, value] };
          else return { ...prev, [name]: arr.filter(item => item !== value) };
        });
      }
    } else {
      // Validate mobile strictly numbers only
      if (name === 'mobile') {
        const val = value.replace(/\D/g, '');
        if (val.length <= 10) setFormData(prev => ({ ...prev, [name]: val }));
      } else {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
    }
    
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = 'Required';
    if (!formData.mobile || formData.mobile.length !== 10) newErrors.mobile = 'Mobile number must be exactly 10 digits';
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Valid Email Address is required';
    if (!formData.city.trim()) newErrors.city = 'Required';
    if (!formData.state.trim()) newErrors.state = 'Required';
    if (!formData.registrationType) newErrors.registrationType = 'Please select a registration type';
    
    if (formData.registrationType === 'trainer' || formData.registrationType === 'both') {
      if (!formData.yearsOfExperience) newErrors.yearsOfExperience = 'Required';
      if (!formData.isCertified) newErrors.isCertified = 'Required';
    }
    
    if (formData.registrationType === 'studio' || formData.registrationType === 'both') {
      if (!formData.studioName.trim()) newErrors.studioName = 'Required';
      if (!formData.studioAddress.trim()) newErrors.studioAddress = 'Required';
    }

    if (!formData.whyJoinYogaKarega.trim()) newErrors.whyJoinYogaKarega = 'Required';
    
    if (!formData.confirmInformation || !formData.agreeToBeListed) {
      newErrors.declaration = 'You must agree to all declarations before submitting';
    }
    
    setErrors(newErrors);
    
    if (Object.keys(newErrors).length > 0) {
      const firstError = document.querySelector('.form-error-msg');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        await apiCall('/partner-applications', 'POST', formData);
        toast.success('Your application has been submitted successfully!');
        setIsSubmitted(true);
        window.scrollTo(0, 0);
      } catch (error) {
        toast.error('Failed to submit application: ' + error.message);
      }
    }
  };

  const renderCheckboxGroup = (name, list) => (
    <div className="checkbox-grid">
      {list.map(item => (
        <label key={item} className="checkbox-label">
          <input type="checkbox" name={name} value={item} checked={formData[name].includes(item)} onChange={handleChange} />
          {item}
        </label>
      ))}
    </div>
  );

  if (isSubmitted) {
    return (
      <div className="partner-registration-container">
        <div className="partner-form-wrapper form-success">
          <h2>Application Submitted!</h2>
          <p>Thank you for your interest in joining Yoga Karega India. Our team will review your application and get back to you shortly.</p>
          <Link to="/" className="back-home-btn">Return to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="partner-registration-container">
      <div className="partner-form-wrapper">
        <div className="partner-form-header">
          <h1>Partner With Us</h1>
          <p>Register as a Yoga Trainer or Yoga Studio/Center with Yoga Karega India</p>
        </div>

        <form className="partner-form" onSubmit={handleSubmit}>
          {errors.declaration && <div className="general-error">{errors.declaration}</div>}

          {/* Section 1: Personal Details */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 1. Personal Details</h2>
            <div className="form-grid">
              <div className="form-group full-width">
                <label>Full Name (Owner Name for Studio) <span className="required-asterisk">*</span></label>
                <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="form-control" placeholder="Enter full name" />
                {errors.fullName && <span className="form-error-msg">{errors.fullName}</span>}
              </div>

              <div className="form-group">
                <label>Mobile Number (WhatsApp preferred) <span className="required-asterisk">*</span></label>
                <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} className="form-control" placeholder="10 digit format" maxLength="10" />
                {errors.mobile && <span className="form-error-msg">{errors.mobile}</span>}
              </div>

              <div className="form-group">
                <label>Email Address <span className="required-asterisk">*</span></label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="example@email.com" />
                {errors.email && <span className="form-error-msg">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label>Gender</label>
                <div className="radio-group">
                  <label className="radio-label"><input type="radio" name="gender" value="Male" onChange={handleChange} /> Male</label>
                  <label className="radio-label"><input type="radio" name="gender" value="Female" onChange={handleChange} /> Female</label>
                  <label className="radio-label"><input type="radio" name="gender" value="Other" onChange={handleChange} /> Other</label>
                </div>
              </div>

              <div className="form-group">
                <label>Date of Birth</label>
                <input type="date" name="dob" value={formData.dob} onChange={handleChange} className="form-control" />
              </div>

              <SearchableSelect
                label="State"
                required
                value={formData.state}
                onChange={val => {
                  setFormData(prev => ({ ...prev, state: val, city: '' }));
                  if (errors.state) setErrors(prev => ({ ...prev, state: null }));
                }}
                options={Object.keys(INDIA_STATES_CITIES).sort()}
                placeholder="Select State"
                error={errors.state}
              />

              <SearchableSelect
                label="City"
                required
                value={formData.city}
                onChange={val => {
                  setFormData(prev => ({ ...prev, city: val }));
                  if (errors.city) setErrors(prev => ({ ...prev, city: null }));
                }}
                options={formData.state ? INDIA_STATES_CITIES[formData.state] || [] : []}
                placeholder={formData.state ? 'Select City' : 'Select State first'}
                error={errors.city}
              />

              <div className="form-group">
                <label>Pin Code</label>
                <input type="text" name="pinCode" value={formData.pinCode} onChange={handleChange} className="form-control" />
              </div>
            </div>
          </div>

          {/* Section 2: Registration Type */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 2. Registration Type <span className="required-asterisk">*</span></h2>
            <div className="radio-group">
              <label className="radio-label"><input type="radio" name="registrationType" value="trainer" checked={formData.registrationType === 'trainer'} onChange={handleChange} /> Yoga Trainer (Individual)</label>
              <label className="radio-label"><input type="radio" name="registrationType" value="studio" checked={formData.registrationType === 'studio'} onChange={handleChange} /> Yoga Studio / Center</label>
              <label className="radio-label"><input type="radio" name="registrationType" value="both" checked={formData.registrationType === 'both'} onChange={handleChange} /> Both</label>
            </div>
            {errors.registrationType && <span className="form-error-msg">{errors.registrationType}</span>}
          </div>

          {/* Section 3: Professional Details - TRAINER */}
          {(formData.registrationType === 'trainer' || formData.registrationType === 'both') && (
            <div className="form-section conditional-trainer">
              <h2 className="form-section-title">👉 3A. Professional Details (Yoga Trainer)</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label>Years of Experience <span className="required-asterisk">*</span></label>
                  <input type="number" name="yearsOfExperience" value={formData.yearsOfExperience} onChange={handleChange} className="form-control" min="0" />
                  {errors.yearsOfExperience && <span className="form-error-msg">{errors.yearsOfExperience}</span>}
                </div>

                <div className="form-group">
                  <label>Languages Spoken</label>
                  <input type="text" name="languagesSpoken" value={formData.languagesSpoken} onChange={handleChange} className="form-control" placeholder="e.g. English, Hindi, Marathi" />
                </div>

                <div className="form-group full-width">
                  <label>Yoga Specialization(s)</label>
                  {renderCheckboxGroup('yogaSpecializations', yogaSpecializationsList)}
                  <input type="text" name="customSpecialization" value={formData.customSpecialization} onChange={handleChange} className="form-control" placeholder="Others (specify)" style={{marginTop: '10px'}} />
                </div>

                <div className="form-group">
                  <label>Are You Certified? <span className="required-asterisk">*</span></label>
                  <div className="radio-group">
                    <label className="radio-label"><input type="radio" name="isCertified" value="Yes" onChange={handleChange} /> Yes</label>
                    <label className="radio-label"><input type="radio" name="isCertified" value="No" onChange={handleChange} /> No</label>
                  </div>
                  {errors.isCertified && <span className="form-error-msg">{errors.isCertified}</span>}
                </div>

                <div className="form-group">
                  <label>Certification Details (Institute + Year)</label>
                  <input type="text" name="certificationDetails" value={formData.certificationDetails} onChange={handleChange} className="form-control" disabled={formData.isCertified !== 'Yes'} />
                </div>

                <div className="form-group full-width">
                  <label>Types of Classes You Offer</label>
                  <div className="checkbox-grid">
                    <label className="checkbox-label"><input type="checkbox" name="typesOfClasses" value="Home Classes" onChange={handleChange} /> Home Classes</label>
                    <label className="checkbox-label"><input type="checkbox" name="typesOfClasses" value="Online Classes" onChange={handleChange} /> Online Classes</label>
                    <label className="checkbox-label"><input type="checkbox" name="typesOfClasses" value="Studio Classes" onChange={handleChange} /> Studio Classes</label>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Section 3: Professional Details - STUDIO */}
          {(formData.registrationType === 'studio' || formData.registrationType === 'both') && (
            <div className="form-section conditional-center">
              <h2 className="form-section-title">👉 3B. Professional Details (Yoga Studio / Center)</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label>Studio Name <span className="required-asterisk">*</span></label>
                  <input type="text" name="studioName" value={formData.studioName} onChange={handleChange} className="form-control" />
                  {errors.studioName && <span className="form-error-msg">{errors.studioName}</span>}
                </div>

                <div className="form-group">
                  <label>Number of Trainers</label>
                  <input type="number" name="numberOfTrainers" value={formData.numberOfTrainers} onChange={handleChange} className="form-control" min="0" />
                </div>

                <div className="form-group full-width">
                  <label>Full Studio Address <span className="required-asterisk">*</span></label>
                  <textarea name="studioAddress" value={formData.studioAddress} onChange={handleChange} className="form-control" rows="3"></textarea>
                  {errors.studioAddress && <span className="form-error-msg">{errors.studioAddress}</span>}
                </div>

                <div className="form-group">
                  <label>Batch Capacity (Students per batch)</label>
                  <input type="text" name="batchCapacity" value={formData.batchCapacity} onChange={handleChange} className="form-control" />
                </div>

                <div className="form-group">
                  <label>Working Days & Timings</label>
                  <input type="text" name="workingDaysTimings" value={formData.workingDaysTimings} onChange={handleChange} className="form-control" placeholder="e.g. Mon-Sat, 6 AM - 8 PM" />
                </div>

                <div className="form-group full-width">
                  <label>Amenities Available</label>
                  {renderCheckboxGroup('amenities', amenitiesList)}
                </div>
              </div>
            </div>
          )}

          {/* Section 4: Services & Pricing */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 4. Services & Pricing</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>Average Fees Setup</label>
                <select name="feeType" value={formData.feeType} onChange={handleChange} className="form-control">
                  <option value="">Select type...</option>
                  <option value="Per Session">Per Session</option>
                  <option value="Monthly Package">Monthly Package</option>
                </select>
              </div>
              <div className="form-group">
                <label>Amount (₹)</label>
                <input type="number" name="feeAmount" value={formData.feeAmount} onChange={handleChange} className="form-control" />
              </div>
              
              <div className="form-group full-width">
                <label>Free Trial Available?</label>
                <div className="radio-group">
                  <label className="radio-label"><input type="radio" name="freeTrial" value="Yes" onChange={handleChange} /> Yes</label>
                  <label className="radio-label"><input type="radio" name="freeTrial" value="No" onChange={handleChange} /> No</label>
                </div>
              </div>

              <div className="form-group full-width">
                <label>Special Programs Offered</label>
                {renderCheckboxGroup('specialPrograms', specialProgramsList)}
                <input type="text" name="customSpecialProgram" value={formData.customSpecialProgram} onChange={handleChange} className="form-control" placeholder="Others (specify)" style={{marginTop: '10px'}} />
              </div>
            </div>
          </div>

          {/* Section 5: Online Presence */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 5. Online Presence (Optional)</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>Website Link</label>
                <input type="url" name="websiteLink" value={formData.websiteLink} onChange={handleChange} className="form-control" placeholder="https://" />
              </div>
              <div className="form-group">
                <label>Instagram Profile</label>
                <input type="text" name="instagramProfile" value={formData.instagramProfile} onChange={handleChange} className="form-control" placeholder="@username" />
              </div>
              <div className="form-group">
                <label>YouTube Channel</label>
                <input type="url" name="youtubeChannel" value={formData.youtubeChannel} onChange={handleChange} className="form-control" />
              </div>
              <div className="form-group">
                <label>Google Maps Location (for studio)</label>
                <input type="url" name="googleMapsLocation" value={formData.googleMapsLocation} onChange={handleChange} className="form-control" />
              </div>
            </div>
          </div>

          {/* Section 6: Documents */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 6. Upload Documents</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>Upload Your Photo / Studio Images</label>
                <div className="file-input">📄 Click to Upload</div>
              </div>
              <div className="form-group">
                <label>Upload Certification Proof</label>
                <div className="file-input">📄 Click to Upload</div>
              </div>
              <div className="form-group full-width">
                <label>Upload ID Proof (Optional)</label>
                <div className="file-input">📄 Click to Upload</div>
              </div>
            </div>
          </div>

          {/* Section 7: Availability */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 7. Availability & Collaboration</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>Are you currently accepting new clients?</label>
                <div className="radio-group">
                  <label className="radio-label"><input type="radio" name="acceptingNewClients" value="Yes" onChange={handleChange} /> Yes</label>
                  <label className="radio-label"><input type="radio" name="acceptingNewClients" value="No" onChange={handleChange} /> No</label>
                </div>
              </div>
              
              <div className="form-group full-width">
                <label>Are you interested in:</label>
                {renderCheckboxGroup('interestedIn', collaborationList)}
              </div>

              <div className="form-group full-width">
                <label>Preferred Service Areas (City/Locality)</label>
                <input type="text" name="preferredServiceAreas" value={formData.preferredServiceAreas} onChange={handleChange} className="form-control" placeholder="E.g., Andheri West, Connaught Place, etc." />
              </div>
            </div>
          </div>

          {/* Section 8: Final Questions */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 8. Final Questions</h2>
            <div className="form-grid">
              <div className="form-group full-width">
                <label>Why do you want to join Yoga Karega India? <span className="required-asterisk">*</span></label>
                <textarea name="whyJoinYogaKarega" value={formData.whyJoinYogaKarega} onChange={handleChange} className="form-control" rows="3"></textarea>
                {errors.whyJoinYogaKarega && <span className="form-error-msg">{errors.whyJoinYogaKarega}</span>}
              </div>
              <div className="form-group full-width">
                <label>Any Additional Information</label>
                <textarea name="additionalInfo" value={formData.additionalInfo} onChange={handleChange} className="form-control" rows="2"></textarea>
              </div>
            </div>
          </div>

          {/* Declaration */}
          <div className="form-section">
            <h2 className="form-section-title">🔹 Declaration <span className="required-asterisk">*</span></h2>
            <div className="form-group">
              <label className="checkbox-label" style={{background:'transparent', border:'none', padding:0, marginBottom:'10px'}}>
                <input type="checkbox" name="confirmInformation" checked={formData.confirmInformation} onChange={handleChange} />
                I confirm that all the information provided is true and accurate.
              </label>
              <label className="checkbox-label" style={{background:'transparent', border:'none', padding:0}}>
                <input type="checkbox" name="agreeToBeListed" checked={formData.agreeToBeListed} onChange={handleChange} />
                I agree to be listed on the Yoga Karega India platform.
              </label>
            </div>
          </div>

          <button type="submit" className="submit-btn">Submit Application</button>
        </form>
      </div>
    </div>
  );
};

export default PartnerRegistration;
